import { useEffect, useState } from 'react';
import './App.scss';
import { setIframeIncomingMessageListener } from './platform/iframe.messaging';
import { useSelector } from 'react-redux';
import { initApp } from 'App.actions';
import { getAppLoaded, getHasApiConnectivityError, setAppLoaded, setHideAngularUntilNavigated } from 'App.reducer';
import { CpLoadingDots } from '@dome9/components/react/components';
import AppRouter from 'AppRouter';
import { getEventTracking, getStoreService } from 'common/interface/services';
import { useLocation } from 'react-router-dom';
import { profileComponent } from 'common/components/profileComponent';
import { ReactComponent as SpriteIcon } from '@dome9/berries/icons/dist/sprite_system-icons.svg';
import { ReactComponent as SpriteVendorIcons } from '@dome9/berries/icons/dist/sprite_vendor-icons.svg';
import { ReactComponent as SpriteLogos } from '@dome9/berries/icons/dist/sprite_logos.svg';
import { Cookies } from 'react-cookie';
import { getBasicUserName } from 'platform/user/User.reducer';
import ModalDialog from 'common/design-system/components-v2/Modal/ModalDialog';
import ModalHeader from 'common/design-system/components-v2/Modal/ModalHeader';
import ModalContent from 'common/design-system/components-v2/Modal/ModalContent';
import { getIsCloudInfra } from 'common/utils/RuntimeEnvironment';
import setupLocatorUI from '@locator/runtime';
import { isAfEnabled } from 'common/utils/debugUtils';
import { changeLanguage } from 'platform/main/Menus/Menus.reducer';

// Setup Locator UI in development mode
if (process.env.NODE_ENV === 'development') {
    setupLocatorUI();
}

setIframeIncomingMessageListener();

const App = () => {
    const appLoaded = useSelector(getAppLoaded);
    const hasApiConnectivityError = useSelector(getHasApiConnectivityError);
    const location = useLocation();
    let userName = useSelector(getBasicUserName);
    const [showDifferentUserModal] = useState<boolean>(false);
    useEffect(() => {
        getEventTracking().pageView();
        if (location.pathname !== decodeURI(window.location.pathname.replace('/v2', ''))) {
            getStoreService().dispatch(setHideAngularUntilNavigated(true));
        }
    }, [location]);

    useEffect(() => {
        window.addEventListener('focus', sessionCheck);
        initApp()
            .then(() => {
                getStoreService().dispatch(setAppLoaded(true));
            })
            .then(async () => {
                if (isAfEnabled('japanese') && getIsCloudInfra()) await changeLanguage('ja');
            });
        return () => {
            window.removeEventListener('focus', sessionCheck);
        };
        // TODO: fix dependencies - if decide to ignore explain why
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userName]);

    const sessionCheck = () => {
        const cookies = new Cookies();
        const cookieUserName = cookies.get('username')?.toLowerCase();
        userName = userName?.toLowerCase();
        if (!getIsCloudInfra() && userName && cookieUserName && cookieUserName !== userName) {
            console.error('Your were signed in with a different user. Please refresh this page');
        }
    };

    if (!appLoaded) {
        return (
            <div className='App'>
                <CpLoadingDots />
            </div>
        );
    }

    if (hasApiConnectivityError) {
        return 'API connectivity error';
    }

    return (
        <div className='App'>
            <div className='App__main'>
                <div className='App__main--content'>
                    <AppRouter />
                </div>
                <ModalDialog width={'lg'} isOpen={showDifferentUserModal}>
                    <ModalHeader title={'Action Required'} onClose={() => window.location.reload()} />
                    <ModalContent>
                        <h3>{'Your were signed in with a different user. Please refresh this page'}</h3>
                    </ModalContent>
                </ModalDialog>
            </div>
            <SpriteIcon className='h-0' style={{ display: 'block', position: 'absolute' }} />
            <SpriteVendorIcons className='h-0' style={{ display: 'block', position: 'absolute' }} />
            <SpriteLogos className='h-0' style={{ display: 'block', position: 'absolute' }} />
        </div>
    );
};

export default profileComponent(App);
